import React from "react";
import "./css/HomePage.css";

const HomePageSkeleton = () => {
  return (
    <div
      className="container py-3 py-md-4 py-xl-5 homepage-shell"
      aria-busy="true"
      aria-label="Loading homepage content"
    >
      {/* 1. Hero Slider Skeleton */}
      <section className="hero-slider-section" aria-hidden="true">
        <div className="hero-slider-card">
          <div className="hero-slider-image-container skeleton-box">
            <div className="skeleton-pulse" />
          </div>
        </div>
      </section>

      {/* 2. Trending Section Skeleton */}
      <section className="homepage-trending" aria-hidden="true">
        <div className="homepage-skeleton-title skeleton-box">
          <div className="skeleton-pulse" />
        </div>
        <div className="homepage-trending-list">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="homepage-skeleton-trending-item">
              <div className="homepage-skeleton-trending-text skeleton-box">
                <div className="skeleton-pulse" />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 3. Subcategories Grid Cards Skeleton */}
      <div className="row g-2 g-md-3 row-cols-2 row-cols-lg-3" aria-hidden="true">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div className="col" key={i}>
            <div className="homepage-card h-100">
              <div className="homepage-image-container">
                <div className="homepage-image skeleton-box">
                  <div className="skeleton-pulse" />
                </div>
              </div>
              <div className="card-body text-center homepage-card-body">
                <div className="homepage-skeleton-card-title skeleton-box">
                  <div className="skeleton-pulse" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePageSkeleton;

